import {useGetPeepOpenTasksCount} from '../../../shared/tasks-widget/hooks/use-get-peep-open-tasks-count';

import {useGetScheduledActivitiesCount} from '../../../../core-entity/widgets/activities-widget/hooks/use-get-scheduled-activities-count';
import type {WidgetCounts} from '../../../../core-entity/workspace/helpers';

import {useGetRelatedContactsCount} from '../related-contacts-widget/hooks/use-get-related-contacts-count';

export function useGetWidgetCounts(entityId: string): WidgetCounts {
    const scheduledActivitiesCount = useGetScheduledActivitiesCount(entityId);
    const relatedContactsCount = useGetRelatedContactsCount(entityId);
    const openTasksCount = useGetPeepOpenTasksCount(entityId);

    return {
        tasks: openTasksCount,
        activities: scheduledActivitiesCount,
        relatedContacts: relatedContactsCount,
    };
}
